import { apiSlice } from "../../app/apiSlice";
import configUrls from "../../config/configUrls";
import { Processo } from "../../types/processo/Processo";
import { ProcessoAnotacao } from "../../types/processo/ProcessoAnotacao";
import { ProcessoAnotacaoDTO } from "../../types/processo/ProcessoAnotacaoDTO";
import { ProcessoAnotacaoList } from "../../types/processo/ProcessoAnotacaoList";
import { ProcessoAtribuirDTO } from "../../types/processo/ProcessoAtribuirDTO";
import { ProcessoAtribuirList } from "../../types/processo/ProcessoAtribuirList";
import { ProcessoAtualizaAndamentoDTO } from "../../types/processo/ProcessoAtualizaAndamentoDTO";
import { ProcessoBlocoDTO } from "../../types/processo/ProcessoBlocoDTO";
import { ProcessoBlocoList } from "../../types/processo/ProcessoBlocoList";
import { ProcessoComentario } from "../../types/processo/ProcessoComentario";
import { ProcessoComentarioDTO } from "../../types/processo/ProcessoComentarioDTO";
import { ProcessoComentarioList } from "../../types/processo/ProcessoComentarioList";
import { ProcessoDTO } from "../../types/processo/ProcessoDTO";
import { ProcessoDarCienciaList } from "../../types/processo/ProcessoDarCienciaList";
import { ProcessoHistoricoAndamentoList } from "../../types/processo/ProcessoHistoricoAndamentoList";
import { ProcessoMarcador } from "../../types/processo/ProcessoMarcador";
import { ProcessoMarcadorDTO } from "../../types/processo/ProcessoMarcadorDTO";
import { ProcessoMarcadorList } from "../../types/processo/ProcessoMarcadorList";

const endpointUrl = configUrls.PROCESSO_EP





function createProcesso(obj: Processo) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function updateProcesso(obj: Processo) {
    return {
        url: `${endpointUrl}/${obj.id}`,
        method: "PUT",
        body: obj,
    }
}

function deleteProcesso({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}
function darCienciaProcesso({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/ciencia?idn=${id}`,
        method: "POST",
    }
}

function favoritarProcesso({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/favorito?idn=${id}`,
        method: "POST",
    }
}

function getProcessoCiencias(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/ciencia/${id}`,
        method: "GET",
    }
}



function getProcessoHistoricos(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/historico/${id}`,
        method: "GET",
    }
}

function atualizarHistoricoProcesso(obj: ProcessoAtualizaAndamentoDTO) {
    return {
        url: `${endpointUrl}/historico`,
        method: "POST",
        body: obj,
    }
}
function atribuirResponsavel(obj: ProcessoAtribuirDTO) {
    return {
        url: `${endpointUrl}/atribuir-responsavel`,
        method: "POST",
        body: obj,
    }
}
function getProcessoAtribuicoes(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/responsaveis/${id}`,
        method: "GET",
    }
}

function getProcessoBlocos({ id, search }: { id: string, search: string }) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/blocos/${id}?search=${search}`,
        method: "GET",
    }
}

function atribuirBloco(obj: ProcessoBlocoDTO) {
    return {
        url: `${endpointUrl}/atribuir-bloco`,
        method: "POST",
        body: obj,
    }
}



function getProcessoAnotacoes({ id, search }: { id: string, search: string }) {

    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }


    return {
        url: `${endpointUrl}/anotacoes/${id}?search=${search}`,
        method: "GET",
    }
}
function addProcessoAnotacao(obj: ProcessoAnotacaoDTO) {
    return {
        url: `${endpointUrl}/anotacao`,
        method: "POST",
        body: obj,
    }
}
function deleteProcessoAnotacao({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/anotacao/${id}`,
        method: "DELETE",
    }
}
function getProcessoAnotacao(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/anotacao/${id}`,
        method: "GET",
    }
}

/**comentarios */


function getProcessoComentarios({ id, search }: { id: string, search: string }) {

    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }


    return {
        url: `${endpointUrl}/comentarios/${id}?search=${search}`,
        method: "GET",
    }
}
function addProcessoComentario(obj: ProcessoComentarioDTO) {
    return {
        url: `${endpointUrl}/comentario`,
        method: "POST",
        body: obj,
    }
}
function deleteProcessoComentario({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/comentario/${id}`,
        method: "DELETE",
    }
}

function deleteAtribuirBloco({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/delete-bloco/${id}`,
        method: "DELETE",
    }
}




function getProcessoComentario(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/comentario/${id}`,
        method: "GET",
    }
}
/** */


/**marcadores */


function getProcessoMarcadores({ id, search }: { id: string, search: string }) {

    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }


    return {
        url: `${endpointUrl}/marcadores/${id}?search=${search}`,
        method: "GET",
    }
}
function addProcessoMarcador(obj: ProcessoMarcadorDTO) {
    return {
        url: `${endpointUrl}/marcador`,
        method: "POST",
        body: obj,
    }
}
function deleteProcessoMarcador({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/marcador/${id}`,
        method: "DELETE",
    }
}
function getProcessoMarcador(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/marcador/${id}`,
        method: "GET",
    }
}
/** */

export const processoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getProcesso: query<Processo, string>({
            query: (id) => `${endpointUrl}/${id}`,
            providesTags: ["Processo"],
        }),

        getProcessoCiencias: query<ProcessoDarCienciaList[], string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getProcessoCiencias,
            providesTags: ["Processo"],
        }),
        getProcessoAtribuicoes: query<ProcessoAtribuirList[], string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getProcessoAtribuicoes,
            providesTags: ["Processo"],
        }),
        getProcessoBlocos: query<ProcessoBlocoList[], { id: string, search: string }>({
            query: getProcessoBlocos,
            providesTags: ["Processo"],
        }),


        getProcessoHistoricos: query<ProcessoHistoricoAndamentoList[], string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getProcessoHistoricos,
            providesTags: ["Processo"],
        }),

        getProcessoAnotacoes: query<ProcessoAnotacaoList[], { id: string, search: string }>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,            
            query: getProcessoAnotacoes,
            providesTags: ["Processo"],
        }),

        getProcessoAnotacao: query<ProcessoAnotacao, string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getProcessoAnotacao,
            providesTags: ["Processo"],
        }),
        getProcessoComentarios: query<ProcessoComentarioList[], { id: string, search: string }>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,            
            query: getProcessoComentarios,
            providesTags: ["Processo"],
        }),

        getProcessoComentario: query<ProcessoComentario, string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getProcessoComentario,
            providesTags: ["Processo"],
        }),



        createProcesso1: mutation<Processo, Processo>(
            {
                query: createProcesso,
                invalidatesTags: ["Processo"]
            }),


        createProcesso: mutation<Processo, ProcessoDTO>(
            {
                query: (obj) => ({
                    url: `${endpointUrl}/create`,  // Usando a variável endpointUrl diretamente
                    method: 'POST',    // Método POST para criar o processo
                    body: obj,         // Corpo da requisição com os dados do novo processo
                }),
                invalidatesTags: ["Processo"]
            }),

        updateProcesso: mutation<Processo, Processo>({
            query: updateProcesso,
            invalidatesTags: ["Processo"]
        }),

        deleteProcesso: mutation<Processo, { id: string }>(
            {
                query: deleteProcesso,
                invalidatesTags: ["Processo"],
            }),

        darCienciaProcesso: mutation<void, { id: string }>(
            {
                query: darCienciaProcesso,
                invalidatesTags: ["Processo"],
            }),
        addHistorico: mutation<void, ProcessoAtualizaAndamentoDTO>({
            query: atualizarHistoricoProcesso,
            invalidatesTags: ["Processo"]
        }),

        addAtribuirResponsavel: mutation<void, ProcessoAtribuirDTO>(
            {
                query: atribuirResponsavel,
                invalidatesTags: ["Processo"]
            }
        ),
        favoritarProcesso: mutation<void, { id: string }>(
            {
                query: favoritarProcesso,
                invalidatesTags: ["Processo"],
            }),
        addAtribuirBloco: mutation<void, ProcessoBlocoDTO>(
            {
                query: atribuirBloco,
                invalidatesTags: ["Processo"]
            }
        ),
        deleteAtribuirBloco: mutation<void, { id: string }>(
            {
                query: deleteAtribuirBloco,
                invalidatesTags: ["Processo"],
            }),

        addAnotacao: mutation<void, ProcessoAnotacaoDTO>({
            query: addProcessoAnotacao,
            invalidatesTags: ["Processo"]
        }),
        deleteAnotacao: mutation<void, { id: string }>(
            {
                query: deleteProcessoAnotacao,
                invalidatesTags: ["Processo"],
            }),
        addComentario: mutation<void, ProcessoComentarioDTO>({
            query: addProcessoComentario,
            invalidatesTags: ["Processo"]
        }),
        deleteComentario: mutation<void, { id: string }>(
            {
                query: deleteProcessoComentario,
                invalidatesTags: ["Processo"],
            }),

        getProcessoMarcadores: query<ProcessoMarcadorList[], { id: string, search: string }>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,            
            query: getProcessoMarcadores,
            providesTags: ["Processo"],
        }),

        getProcessoMarcador: query<ProcessoMarcador, string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getProcessoMarcador,
            providesTags: ["Processo"],
        }),
        addProcessoMarcador: mutation<void, ProcessoMarcadorDTO>({
            query: addProcessoMarcador,
            invalidatesTags: ["Processo"]
        }),
        deleteProcessoMarcador: mutation<void, { id: string }>(
            {
                query: deleteProcessoMarcador,
                invalidatesTags: ["Processo"],
            }),

    }),

});
export const {
    useGetProcessoQuery,
    useGetProcessoCienciasQuery,
    useCreateProcessoMutation,
    useUpdateProcessoMutation,
    useDeleteProcessoMutation,
    useCreateProcesso1Mutation,
    useDarCienciaProcessoMutation,
    useAddHistoricoMutation,
    useGetProcessoHistoricosQuery,
    useAddAtribuirResponsavelMutation,
    useGetProcessoAtribuicoesQuery,
    useFavoritarProcessoMutation,
    useGetProcessoBlocosQuery,
    useAddAtribuirBlocoMutation,
    useGetProcessoAnotacoesQuery,
    useAddAnotacaoMutation,
    useDeleteAnotacaoMutation,
    useGetProcessoAnotacaoQuery,
    useAddComentarioMutation,
    useDeleteComentarioMutation,
    useGetProcessoComentariosQuery,
    useGetProcessoComentarioQuery,
    useGetProcessoMarcadoresQuery,
    useGetProcessoMarcadorQuery,
    useDeleteProcessoMarcadorMutation,
    useAddProcessoMarcadorMutation,
    useDeleteAtribuirBlocoMutation,

} = processoApiSlice